<template lang="pug">
  .trace-map
    SspLayout(area="tnt")
      template(slot="actions")
        button.btn.btn-default(@click="$router.go(-1)") Back
      .row
        .col-sm-12(v-if="!loading")
          GmapMap(ref="map" :center="center" :zoom="2" style="height: 700px;")
            GmapMarker(:key="index" v-for="(m, index) in markers" :position="m" :icon="markerIcon" @click="center=m" @mouseover="message = m.message" @mouseout="message = null")
            GmapPolyline(:path="markers" :options="{strokeColor: '#004FE1'}")
            GmapPolyline(v-if="targetPath.length === 2" :path="targetPath" :options="polylineOptions")
            GmapMarker(:position="targetPath[1]" :icon="markerIcon" @mouseover="message = targetDetails" @click="center=targetPath[1]" @mouseout="message = null")

          .details-wrapper
            .details(v-if="message")
              .p10(:key="index" v-for="(text, index) in message") {{text}}


</template>

<script>
import GmapLazy from '@/utils/GmapLazy'
import TrackNTrace from '@/service/apis/TrackNTrace'
import { bizStepFilter, dispositionFilter } from '@/components/pages/trackntrace/utils'
import { dateFilter } from '@/filters/filters'

export default {
  data: () => ({
    loading: false,
    markers: null,
    center: { lat: 0, lng: 0 },
    message: null,
    targetDetails: {},
    targetPath: [],
    markerIcon: {
      path: 0,
      scale: 8,
      fillOpacity: 1,
      strokeColor: '#e4ff1a',
      fillColor: '#e4ff1a',
      strokeWeight: 3.0,
    },
    polylineOptions: {
      strokeColor: '#004FE1',
      strokeOpacity: 0,
      icons: [{
        icon: {
          path: 'M 0,-1 0,1',
          strokeOpacity: 1,
          scale: 4
        },
        offset: '0',
        repeat: '20px'
      }]
    }
  }),
  mounted() {
    GmapLazy.loadGmap()
      .then(this.fetchData)
  },
  methods: {
    fetchData() {
      this.loading = true
      TrackNTrace.traceCode(this.code)
        .then((resp) => {
          const locations = {}
          const markers = resp.data.events.event
            .filter((e) => e.location)
            .map((p) => {
              locations[p.location.id] = p.location.coordinates
              return {
                lat: p.location.coordinates.latitude,
                lng: p.location.coordinates.longitude,
                message: [p.location.name, dispositionFilter(p.disposition), bizStepFilter(p.bizStep), dateFilter(p.eventTime)]
              }
            })
          this.markers = markers
        })
        .then(() => {
          TrackNTrace.findShipmentByCode(this.code)
            .then((shipment) => TrackNTrace.findBusinessLocation(shipment.data.targetLocation.id))
            .then((t) => {
              const { data } = t
              this.targetDetails = {
                note: 'Target Location',
                country: data.county ? data.country.name : null,
                name: data.name,
              }
              this.targetPath.push(this.markers[0])
              this.targetPath.push(data.coordinates)
            })
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => {
          this.loading = false
        })
    }
  },
  computed: {
    code() {
      return this.$route.params.code
    }
  },
  components: {
    GmapLazy
  },
  filters: {
    date: dateFilter,
    disposition: dispositionFilter,
    bizStep: bizStepFilter
  }
}
</script>

<style lang="scss">
.trace-map {
  .details-wrapper {
    bottom: 0%;
    background-color: #004FE1;
    color: white;
    position: absolute;
    z-index: 100;
    font-size: 20px;
    font-family: 'MarkPro';
    text-align: left;

    .details {
      padding: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/trace/TraceMap.vue